import styled from 'styled-components';

const InputAuthentication = styled.input`
  font-size: 18px;
  font-family: 'Inter', sans-serif;
  margin-top: 8px;
  margin-bottom: 16px;
  display: block;
  width: 100%;
  padding: 8px;
  background-color: transparent;
  border-radius: 8px;
  border: 3px solid var(--on-background);
  color: var(--on-background);
`;

export default InputAuthentication;
